import styled from "styled-components";
import { GRAY_100 } from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";

export const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px ${(props) => (props.compact ? "5px" : "8px")};
  background-color: ${GRAY_100};
  border-radius: 5px;
  width: fit-content;
  cursor: ${(props) => (props.hasTooltip ? "pointer" : "default")};
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  flex-shrink: 0;
`;

export const StatusText = styled.span`
  font-weight: ${fontWeights.semibold};
  font-size: ${sizes.small};
  line-height: 1.5em;
  white-space: nowrap;
`;
